// Product description "Continue reading": opens the capped description in place
// (snippets/brcr-product-blocks.liquid, "description" block).
(function () {
  if (window.brcrDescInit) return;
  window.brcrDescInit = true;

  function open(button, desc) {
    desc.classList.remove('is-clamped');
    button.setAttribute('aria-expanded', 'true');
    button.hidden = true;
  }

  // If the capped text already fits, there is nothing to open: show it whole, hide the button.
  function check(root) {
    root.querySelectorAll('.brcr-desc__more[aria-expanded="false"]').forEach(function (button) {
      var desc = document.getElementById(button.getAttribute('aria-controls'));
      if (desc && desc.scrollHeight <= desc.clientHeight + 1) open(button, desc);
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.brcr-desc__more');
    if (!button) return;
    var desc = document.getElementById(button.getAttribute('aria-controls'));
    if (!desc) return;
    open(button, desc);
    // The button disappears, so keep keyboard focus on the text it opened.
    desc.focus({ preventScroll: true });
  });

  check(document);
  window.addEventListener('load', function () { check(document); });
  document.addEventListener('shopify:section:load', function (event) { check(event.target); });
})();
